const cache = localStorage.getItem('offer_category_cache');
const categories = JSON.parse(cache) || [];

export default {
	categories: [...categories],
	loaded: !!cache
};
